import { css } from 'styled-components';

export const toggleHideWithOpacityAnimation = ($hidden?: boolean) => css`
    opacity: 1;
    transition: opacity 0.3s ease;
    pointer-events: auto;

    ${$hidden &&
    css`
        opacity: 0;
        pointer-events: none; /* Отключает клики */
    `}
`;

export const toggleHideWithTranslateAnimation = ($hidden?: boolean, $transformDirection?: string) => css`
    transition: transform 0.2s ease-in-out;
    transform: translateY(0);

    ${$hidden &&
    css`
        transform: ${$transformDirection || 'translateY(100%)'};
    `}
`;

/**
 * анимашка плавного появления видео при загрузке
 */
export const videoFadeInAnimation = css<{ $isReady?: boolean }>`
    opacity: ${({ $isReady }) => ($isReady === false ? '0' : '1')};
    transform: var(--video-base-transform);
    animation: ${({ $isReady }) => ($isReady ? 'fadeInVideo 0.4s ease-out forwards' : 'none')};

    @keyframes fadeInVideo {
        from {
            opacity: 0;
            transform: var(--video-base-transform) scale(0.98);
        }
        to {
            opacity: 1;
            transform: var(--video-base-transform) scale(1);
        }
    }
`;
